
import { Tabs, Tab, Empty } from '@atom/atom-ui';
import '@atom/atom-ui/lib/tabs/style';
import '@atom/atom-ui/lib/tab/style';
import '@atom/atom-ui/lib/empty/style';
import { isInvalid, isTrueArray, jumpWeb } from '@king-fisher/mobileweb-lib';
import StockListBusiness from '@mobileweb/StockListBusiness';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getAiContent } from '@/apis';
import { statClick } from '@/config/stat';
import { AI_WORKFLOW_CONFIG, AI_CONTENT_DETAIL_URL, DEFAULT_HOT_BLOCK_TAB } from '@/config/config';

// 表格外边距适配REM方案
(StockListBusiness as any).methods.getTableMargin = () => '0.32rem';
// toast使用项目内置，保持样式统一
(StockListBusiness as any).methods.toast = msg => Vue.prototype.$toast(msg);

@Component({
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Empty.name]: Empty,
    StockListBusiness,
  },
})
export default class HotIndustryList extends Vue {
  @Prop({ default: 5 }) private pageSize: number;
  @Prop({ default: false }) private enablePage: boolean;
  @Prop({ default: false }) private enableSort: boolean;
  @Prop({ default: false }) private fixedHeader: boolean;

  activeTag = window.getParam('tab') || DEFAULT_HOT_BLOCK_TAB;

  indexes = [
    {
      index_id: 'security_name',
    },
    {
      index_id: 'price_change_ratio_pct',
    },
    {
      index_id: 'ths-hot-data-minute-attention-rate',
    },
  ];

  get codeSelector() {
    return {
      include: [
        {
          type: 'tag',
          values: [this.activeTag],
        },
      ],
    };
  }

  get columnMap() {
    return {
      security_name: {
        customCell: null,
        fixed: null,
        width: '2.44rem',
      },
      price_change_ratio_pct: {
        title: '涨幅',
        cellFieldsOption: {
          thsFontMoney: true,
          isRedGreen: true,
          textFormat: '+M.2%',
        },
        width: '1.92rem',
        sortBy: this.enableSort,
      },
      'ths-hot-data-minute-attention-rate': {
        title: '热度',
        cellFieldsOption: {
          thsFontMoney: true,
          textFormat: 'RMB',
        },
        width: '1.66rem',
        sortBy: this.enableSort,
      },
    };
  }

  get page() {
    return {
      size: this.pageSize,
      enablePagination: this.enablePage,
      frontControl: true,
    };
  }

  sort = {
    key: 'ths-hot-data-minute-attention-rate',
    order: 'desc',
  };

  requestConfig = {
    afterResponse: async payload => {
      const tableIns = payload.instance;
      const isFirstPage =
        payload.finalRequestParam.page_info.page_begin === 0 &&
        payload.finalRequestParam.code_selectors.include;
      if (isFirstPage && !isTrueArray(payload.data)) {
        setTimeout(() => (tableIns.showEmpty = true), 0);
        return;
      }

      const workflow_id = AI_WORKFLOW_CONFIG.HOT_BLOCK_SUMMARY;
      const symbol = payload.data.map(item => `${item.market}:${item.code}`).join(',');
      const { data = [] } = payload;
      const res: any = await getAiContent(new URLSearchParams({ workflow_id, symbol }).toString());
      const result = res.data.resultList || [];
      data.forEach(item => {
        const match = result.find(r => r.symbol === `${item.market}:${item.code}`);
        if (match && !isInvalid(match.content)) {
          try {
            item.content = JSON.parse(match.content);
          } catch (e) {
            item.content = null;
          }
        }
      });

      if (isFirstPage) {
        const expandRows = this.expandOption.defaultExpandedRowKeys;
        expandRows.length = 0;
        expandRows.push(payload.data[0].code);
      }
    },
    beforePollingRequest: payload => {
      delete payload.sort;
    },
    afterPollingResponse: payload => {
      const { tableData } = payload.instance;
      payload.data.forEach(item => {
        const match = tableData.find(r => r.code === item.code);
        item.content = match ? match.content : null;
      });
    },
  };

  expandOption = {
    expandable: true,
    expandOnly: true,
    expandRowHeight: ({ row }) => {
      // 取row.content.summary，然后设置到hiddenElm中，测量高度
      if (row.content && row.content.summary && this.$refs.hiddenElm) {
        (this.$refs.hiddenElm as HTMLElement).innerText = row.content.summary;
        return `${(this.$refs.hiddenElm as HTMLElement).offsetHeight}px`;
      }
      return '3.42rem';
    },
    defaultExpandedRowKeys: [],
  };

  toIndustryPage(code, market) {
    statClick('ths_mob_yanbao_hotBlock_pageJump');
    jumpWeb(`${AI_CONTENT_DETAIL_URL}&stockCode=${code}&marketId=${market}`);
  }

  handleRowClick({ row }) {
    statClick('ths_mob_yanbao_hotBlock_pageJump');
    jumpWeb(`${AI_CONTENT_DETAIL_URL}&stockCode=${row.code}&marketId=${row.market}`);
  }

  handleExpandedRowsChange() {
    statClick('ths_mob_hotBlockInterpret_contenArea_openPanel');
  }

  handleTabChange(name) {
    statClick('ths_mob_yanbao_hotBlock_qiehuantab', { tabName: name.split('_')[1] });
    this.$emit('tabChange', name);
  }
}
